import React, {useState} from 'react';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import {connect} from 'react-redux';
import {create_customer} from '../../redux/actions/adminActions';
import {Modal} from 'react-bootstrap';
import ProfileEdit from '../admin/suppliers/profileEdit';
import LicenseCapture from '../admin/suppliers/licenseCapture';
import ResetPassword from '../admin/suppliers/resetPassword';

function CreateSupplierModal({show, handleClose, createCustomer, accessToken}) {

    const [newUser,
        setNew] = useState({});

    const [index,
        setIndex] = useState(0);

    const handleInputChange = (input) => {
        let body = {
            ...newUser,
            ...input
        };
        setNew(body);
        handleCreate(body);
    }

    const handleCreate = (data) => {

        let formdata = new FormData();

        formdata.append("display_pic", data
            ?.sent_display_pic);
        formdata.append("first_name", data
            ?.first_name);
        formdata.append("last_name", data
            ?.last_name);
        formdata.append("address", data
            ?.address);
        formdata.append("email", data
            ?.email);
        formdata.append("phone", data
            ?.phone);
        formdata.append("id_upload", data
            ?.sent_id_upload);
        formdata.append("proof_of_address", data
            ?.sent_proof);
        formdata.append("password", data
            ?.password);
        formdata.append("password_confirmation", data
            ?.password_confirmation);
        formdata.append("id_type", data
            ?.id_type);
        formdata.append("id_number", data
            ?.id_number);

        createCustomer(formdata, accessToken, () => {
            setIndex(0);
            // handleClose();
        });
    }

    return (
        <Modal show={show} onHide={handleClose} centered>
            <div className="icon--tiny isClickable closeModal" onClick={handleClose}>
                <i class="ri-close-line sectionText--small"></i>
            </div>

            <div className="suppliers py-4">
                <Tabs selectedIndex={index}>
                    <TabList className='alignOnly sectionText pl-0 p-2 mb-0'>
                        <Tab className='tabHead'>Profile</Tab>
                        <Tab className='tabHead'>Driver’s License/Passport</Tab>
                        <Tab className='tabHead'>Password</Tab>
                    </TabList>

                    <TabPanel>
                        <ProfileEdit
                            customer
                            newUser
                            submit={(data) => setNew({
                            ...newUser,
                            ...data
                        })}
                            next={() => setIndex(index + 1)}/>
                    </TabPanel>
                    <TabPanel>
                        <LicenseCapture
                            customer
                            submit={(data) => setNew({
                            ...newUser,
                            ...data
                        })}
                            prev={() => setIndex(0)}
                            next={() => setIndex(index + 1)}
                            newUser/>
                    </TabPanel>
                    <TabPanel>
                        <ResetPassword newUser customer submit={(input) => handleInputChange(input)}/>
                    </TabPanel>
                </Tabs>
            </div>
        </Modal>

    )
}

const mapStateToProps = (state) => ({accessToken: state.admin.token})

const mapDispatchToProps = (dispatch) => ({
    createCustomer: (data, token, success) => dispatch(create_customer(data, token, success))
})

export default connect(mapStateToProps, mapDispatchToProps)(CreateSupplierModal)
